'use strict';

const Seguranca = {
    gerarSenhaAletoria: (tamanho = 10, maiuscula = true, minuscula = true, numeros = true, especiais = true) => {
        tamanho = tamanho <= 32 ? tamanho : 32; //Definindo tamanho máximo da senha;

        const maius = 'ABCDEFGHIJKLMNOPQRSTUWXYZ';
        const minus = 'abcdefghijklmnopqrstuwxyz';
        const numer = '0123456789';
        const espec = '!@#$%&*()+?{[}]><';

        let stringBase = '';
        stringBase += maiuscula ? maius : '';
        stringBase += minuscula ? minus : '';
        stringBase += numeros ? numer : '';
        stringBase += especiais ? espec : '';

        let novaSenha = '';
        for (let i = 0; i < tamanho; i++) {
            const posicao = Math.floor(Math.random() * String(stringBase).length);
            novaSenha += stringBase.substring(posicao, posicao + 1);
        }
        return novaSenha;
    }
};

module.exports = Seguranca;
